/**
 * The poster's size or finish choices on mobile and in the app (design handoff "Éditeur mobile") :
 * a sheet rising from the bottom over a dimmed editor, the cards of
 * shared.components.PosterSizeOptions / PosterFinishOptions — the desktop screens' — two by two,
 * and no close button, on purpose. It closes on a choice (shown 180 ms first), a touch on the
 * dimmed editor, the handle pulled down past 100 px, Escape and the phone's back button — the
 * sheet stands as one step of the history (the browser's, and the app's webview going back) ; the
 * focus goes back to whatever opened it.
 *
 *   new shared.popups.PosterOptionsSheet(model, "size" | "finish")
 *
 * Opened by mobile.poster.PosterMain on "size-choice" / "frame-choice".
 */
fx.ns("shared.popups", class PosterOptionsSheet extends fx.components.Popup {

    constructor(model, kind)
    {
        super(model);

        this.kind = kind == "finish" ? "finish" : "size";
        this.showClose = false;
        this.modal = false;             // the sheet dims the editor itself
        this.effect = "";               // and slides itself in
        this._opener = document.activeElement;
    }

    get ARTWORK_RATIO() { return 2; }
    get CHOICE_DELAY() { return 180; }
    get SLIDE() { return 300; }
    get PULL_TO_CLOSE() { return 100; }

    create()
    {
        super.create();

        this.choices = this.kind == "finish"
            ? new shared.components.PosterFinishOptions(this.data, { mobile : true })
            : new shared.components.PosterSizeOptions(this.data, { mobile : true });

        this.view = new shared.components.PosterOptionsView({ title : this.choices.title, subtitle : this.choices.subtitle, kind : this.choices.kind, sheet : true });
        this.addChild(this.view, { width : "100%", height : "100%", top : 0, left : 0 });
    }

    onReady()
    {
        super.onReady();

        this.on("ESCAPE", this._close, fx.keyboard);
        this._listenBack();

        // the mobile popup builds its content after itself : the view is filled once it exists
        if (this.view.initialized)
            this._fill();
        else
            this.on("ready", this._fill, this.view);
    }

    _fill()
    {
        if (this._filled || !this.view || !this.view.node)
            return;

        this._filled = true;
        this.on("click", this._onClick, this.view.node);
        this.view.onPulled = () => this._close();
        this.view.cards(this.choices.cards());

        shared.preview3d.PosterArtwork.render(this, this.data, this.ARTWORK_RATIO).then((url) => {
            if (url && this.view && this.view.node)
                this.view.artwork(url);
        });

        this.delay(() => this.view && this.view.focusSelected(), this.SLIDE);
    }

    // back closes the sheet rather than leaving the editor : one entry pushed on opening, at the
    // same address, taken back off whatever closes the sheet
    _listenBack()
    {
        if (!window.history || !history.pushState)
            return;

        history.pushState({ posterSheet : this.id }, "");
        this._onBack = () => {
            this._unlistenBack();
            this._close();
        };
        window.addEventListener("popstate", this._onBack);
    }

    _unlistenBack()
    {
        if (!this._onBack)
            return false;

        window.removeEventListener("popstate", this._onBack);
        this._onBack = null;
        return true;
    }

    destroy()
    {
        // closed some other way : the entry pushed for it goes
        if (this._unlistenBack() && history.state && history.state.posterSheet == this.id)
            history.back();

        if (this._opener && this._opener.focus && document.body.contains(this._opener))
            this._opener.focus({ preventScroll : true });

        super.destroy();
    }

    _onClick(e)
    {
        let target = e.target && e.target.closest ? e.target.closest("[data-action]") : null;
        if (!target || target.disabled || this._closing)
            return;

        if (target.dataset.action == "close")
            return this._close();

        if (target.dataset.action == "choose")
        {
            // the poster follows at once, the sheet once the choice has been seen
            this.view.select(target.dataset.id);
            this.choices.apply(target.dataset.id);
            this.delay(() => this._close(), this.CHOICE_DELAY);
        }
    }

    // slid down, then gone
    _close()
    {
        if (this._closing)
            return;

        this._closing = true;
        this.view.closing();
        this.delay(() => this.close(), this.SLIDE);
    }
});
